import { LocationRefFragment } from "./location-ref";
import { OrderItemFragment } from "./order-item";
import { ReceiptFragment } from "./receipt";
import { UserRefFragment } from "./user-ref";

export const OrderFragment = /* GraphQL */ `
	fragment OrderFragment on Order {
		_id
		created_at
		updated_at
		index
		prepared_at
		processed_at
		paid_at
		cancelled_at
		prepared_by
		processed_by
		paid_by
		cancelled_by
		customer
		venue
		status
		is_paid
		staff
		original_orders
		cancelled_reason
		source
		device
		prep_time
		currencies_configs
		location
		current_location
		items {
			...OrderItemFragment
		}
		cancelled_items {
			...OrderItemFragment
		}
		max_prepare_time
		items_count
		items_count_by_types
		prepped_count
		subtotal
		offer_amount
		discount_amount
		net_amount
		vat_amount
		service_charge_amount
		service_charge_bd_amount
		tax_amount
		card_surcharge_amount
		non_sales_credit_amount
		adjustment_amount
		grand_total
		gross_amount
		cancelled_amount
		receipt
		is_needing_prep_time_confirmation
		is_needing_prep_time_acknowledgement
		note
		is_cancelled
		is_bill_printed
		is_needing_payment_confirmation
		headcount
		temp_index
		_staff {
			...UserRefFragment
		}
		_prepared_by {
			...UserRefFragment
		}
		_processed_by {
			...UserRefFragment
		}
		_paid_by {
			...UserRefFragment
		}
		_cancelled_by {
			...UserRefFragment
		}
		_location {
			...LocationRefFragment
		}
		_current_location {
			...LocationRefFragment
		}
		_customer {
			_id
			first_name
			last_name
		}
		_receipt {
			...ReceiptFragment
		}
	}
	${OrderItemFragment}
	${UserRefFragment}
	${LocationRefFragment}
	${ReceiptFragment}
`;
